export default [
  {
    path: '/activity-20260720-main',
    component: () => import('./Page.vue'),
    meta: {
      title: 'HiFun一碰到底',
      activity_code: 'activity_20260720_hitbottom',
      activity_id: 37,
    },
  },
  {
    path: '/activity-20260720-rule',
    component: () => import('./Rule.vue'),
    meta: {
      title: '活动规则',
      activity_code: 'activity_20260720_hitbottom',
      activity_id: 37,
    },
  },
]
